import { withFormField } from "@swa-ui/form";

import { NewPassword } from "../NewPassword";

/**
 * NewPasswordFormField provides support for a NewPassword component to be used in a Form.
 */

export const NewPasswordFormField = withFormField(NewPassword);
